export default function CoachDirectorClassManagement () {

  return (
    <div>
      this is coach logged in Coach Director Class Management
    </div>
  )
}